/*
  eslint-disable
  jsx-a11y/anchor-is-valid,
  jsx-a11y/click-events-have-key-events
*/
// @flow

import React, { type Node } from 'react';
import cx from 'classnames';

type Props = {
  checked: boolean,
  className?: string,
  imageUrl?: string,
  clickHandler?: Function | null,
  leftContent?: Node | null,
  rightContent?: Node | null,
};

// TODO: make this a button and remove eslint-disable rules
const SelectionListItem = (props: Props) => (
  <a
    className={cx('flex-row selection-list-item', props.className, {
      checked: props.checked,
      'has-image': !!props.imageUrl,
    })}
    onClick={props.clickHandler}>
    {!!props.imageUrl && (
      <div className="img-holder">
        <img src={props.imageUrl} alt="" />
      </div>
    )}
    <div style={{ flexGrow: 1 }}>{props.leftContent}</div>
    {props.rightContent}
  </a>
);

SelectionListItem.defaultProps = {
  className: '',
  imageUrl: '',
  clickHandler: null,
  leftContent: null,
  rightContent: null,
};

export default SelectionListItem;
